export enum EUserPermissions {
	ADMIN = 'admin',
	CMS_PL = 'edit_cms_pl',
	CMS_EN = 'edit_cms_en',
}
